export default "__VITE_ASSET__BnFAN7Pd__"